<template>
  <div class="body">
    <el-container v-show="show">
      <el-header class="headerel">
        <toubu class="tou"></toubu>
      </el-header>
      <!-- <el-main v-if="qita"> <router-view></router-view></el-main> -->
      <el-container v-if="baojia" style="margin-top: 60px">
        <el-aside :width="wid" class="asides">
          <cebianlan></cebianlan>
        </el-aside>
        <el-main :style="{ paddingLeft: paddLift }">
          <router-view></router-view>
          <footer class="main-footer" style="font-size: 10pt">
            <div>
              <span>{{ $WEB.$STORE.state.Company }}</span
              >&nbsp; <span>.© 2010-{{ new Date().getFullYear() }}</span
              >&nbsp;
              <span>
                <el-link
                  style="vertical-align: baseline; font-weight: bold"
                  type="info"
                  :underline="false"
                  href="https://beian.miit.gov.cn"
                  target="_blank"
                >
                  {{ $WEB.$STORE.state.ICP }}
                </el-link>
              </span>
              &nbsp;
              <span>
                技术支持:
                <a href="http://www.itongyin.com" target="_blank"> 通印科技 </a>
              </span>

              <span
                v-if="$WEB.$STORE.state.AnQuanBeiAn"
                v-html="$WEB.$STORE.state.AnQuanBeiAn"
              >
              </span>
            </div>
          </footer>
        </el-main>
      </el-container>
    </el-container>
    <zaixiankefu v-show="show"></zaixiankefu>
  </div>
</template>

<script>
import toubu from "@/views/shouyeZujian/toubu";
import cebianlan from "@/views/shouyeZujian/cebianlan";
import zaixiankefu from "@/views/components/zaixiankefu";
export default {
  components: { toubu, cebianlan, zaixiankefu },
  data() {
    return {
      wid: "260px",
      paddLift: "280px",
      baojia: true,
      qita: false,
    };
  },
  watch: {
    listenshow() {
      this.wid = this.$store.state.changableNum;
      this.paddLift = this.$store.state.paddingLefts;
    },
  },
  computed: {
    show() {
      return sessionStorage.getItem("__flag__") != "PAY";
    },
    listenshow() {
      return this.$store.state.changableNum;
    },
    paddingLe() {
      return this.$store.state.paddingLefts;
    },
  },
};
</script>
<style scoped>
.widthfix {
  width: inherit;
}
.el-header,
.el-footer {
  background-color: #fff;
  color: #333;
  line-height: 60px;
  height: 60px !important;
  box-shadow: 0 4px 10px 0 rgba(48, 62, 83, 0.06);
  position: fixed;
  width: 100%;
  z-index: 2000;
}
.el-header {
  line-height: 50px;
  text-align: center;
}
.asides {
  z-index: 200;
}
.el-aside {
  background-color: #fff;
  color: #333;
  padding-top: 60px;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
}

.el-main {
  color: #333;
  /* padding-left: 220px; */
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.zhu {
  padding: 10px;
}
.main-footer {
  background: #fff;
  padding: 15px 15px 15px 15px;
  color: #444;
  margin-top: 20px;

  border-top: 1px solid #d2d6de;
}

@media screen and (max-width: 768px) {
  .asides {
    display: none;
  }
  .headerel {
    background: #b3d8ff;
  }
  .el-main {
    padding-left: 0px !important;
    padding-right: 0px;
  }
  .main-footer {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/shouye.vue